import Image from 'next/image';
import { parseHtml } from '@/lib/parse-html';
import ThreeColumnMediaFull, { ThreeColumnMediaFullProps } from '@/components/_rebrand/ThreeColumnMediaFull';
import SerifAndSansSerifHeadline, { HeadlineFromCraftProps } from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';

const displayProps = {
  title: null,
  features: [],
  mainImage: null,
} as ThreeColumnMediaFullProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

interface BenefitFromCraft {
  headline: string;
  icon: AssetImageFromCraft;
  description: string;
}

interface ModuleProduct3xBenefits {
  headline: string;
  header: HeadlineFromCraftProps;
  eyebrowText: string;
  description: string;
  featuredImage: AssetImageFromCraft;
  mobileFeaturedImage: AssetImageFromCraft;
  benefits: BenefitFromCraft[];
}


const formBenefits = (features: BenefitFromCraft[]): ThreeColumnMediaFullProps['features'] => {
  const benefits: ThreeColumnMediaFullProps['features'] = features.map((feature) => ({
    icon: <Image src={feature.icon[0].url} width={feature.icon[0].width} height={feature.icon[0].height} style={{ width: 16 }} alt={feature.icon[0].title} />,
    title: feature.headline,
    description: parseHtml(feature.description),
  }));

  return benefits;
}

const formMainImage = (featuredImage: AssetImageFromCraft, mobileFeaturedImage: AssetImageFromCraft): ThreeColumnMediaFullProps['mainImage'] => {
  return <>
    <Image src={featuredImage.url} width={featuredImage.width} height={featuredImage.height} alt={featuredImage.alt} className="hidden md:block" />
    <Image src={mobileFeaturedImage.url} width={mobileFeaturedImage.width} height={mobileFeaturedImage.height} alt={mobileFeaturedImage.alt} className="block md:hidden" />
  </>
}

const setDynamicDisplayPropAttributes = (entry: any) => {
  const data = Array.isArray(entry?.moduleProduct3xBenefits)
    ? entry.moduleProduct3xBenefits[0]
    : entry?.moduleProduct3xBenefits;

  displayProps.title = <SerifAndSansSerifHeadline {...data.header[0]} />
  displayProps.features = formBenefits(data.benefits);
  displayProps.mainImage = formMainImage(data.featuredImage[0], data.mobileFeaturedImage[0]);
}

const ThreeBenefits = ({ entry }) => {
  setDynamicDisplayPropAttributes(entry);

  return (
      <ThreeColumnMediaFull {...displayProps} />
  );
};

export default ThreeBenefits;

